import img1 from "../images/logo-company/cty16.png";
import img2 from "../images/logo-company/cty17.png";
import img3 from "../images/logo-company/cty11.png";
import img4 from "../images/logo-company/cty10.png";
import img5 from "../images/logo-company/cty13.png";
import img6 from "../images/logo-company/cty14.png";
import img7 from "../images/logo-company/cty15.png";
import img8 from "../images/logo-company/cty9.png";
import img9 from "../images/logo-company/cty12.png";
import img10 from "../images/logo-company/cty6.png";
import img11 from "../images/logo-company/cty7.png";
import img12 from "../images/logo-company/cty3.png";

const dataEm = [
  {
    id: 1,
    img: img1,
    title: "Samsung",
    map: "Las Vegas, NV 89107, USA",
    job: "0 job openings",
  },
  {
    id: 2,
    img: img2,
    title: "Utilitech",
    map: "Las Vegas, NV 89107, USA",
    job: "1 job openings",
  },
  {
    id: 3,
    img: img3,
    title: "Samsung",
    map: "Las Vegas, NV 89107, USA",
    job: "7 job openings",
  },
  {
    id: 4,
    img: img4,
    title: "Samsung",
    map: "Las Vegas, NV 89107, USA",
    job: "3 job openings",
  },
  {
    id: 5,
    img: img5,
    title: "Rigid",
    map: "Las Vegas, NV 89107, USA",
    job: "2 job openings",
  },
  {
    id: 6,
    img: img6,
    title: "Task Force",
    map: "Las Vegas, NV 89107, USA",
    job: "2 job openings",
  },
  {
    id: 7,
    img: img7,
    title: "Black & Decker",
    map: "Las Vegas, NV 89107, USA",
    job: "4 job openings",
  },
  {
    id: 8,
    img: img8,
    title: "Amanda",
    map: "Las Vegas, NV 89107, USA",
    job: "2 job openings",
  },
  {
    id: 9,
    img: img9,
    title: "Electrolux",
    map: "Las Vegas, NV 89107, USA",
    job: "5 job openings",
  },
  {
    id: 10,
    img: img10,
    title: "Whirlpool",
    map: "Las Vegas, NV 89107, USA",
    job: "6 job openings",
  },
  {
    id: 11,
    img: img11,
    title: "Bosch",
    map: "Las Vegas, NV 89107, USA",
    job: "7 job openings",
  },
  {
    id: 12,
    img: img12,
    title: "Samsung",
    map: "Las Vegas, NV 89107, USA",
    job: "8 job openings",
  },
];

export default dataEm;
